module.exports = __webpack_public_path__ + "static/img/default-header.c68ea26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-header.png
// module id = Ot9E
// module chunks = 1